import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10400;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(6px);
`;

export const ModalWrapper = styled.div`
  width: 100%;
  height: 100vh;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const Close = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #EAF0D5;
  color: black;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: center;
  flex: 1;
  .img {
    margin-bottom: 30px;
  }
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: black;
  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media screen and (max-width: 320px) {
    margin-right: 10px;
  }

  &.header {
    justify-content: space-between;
    border-bottom: solid 3px #000;
    padding: 16px;
  }
`;

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  border: 1px solid gray;
  background: #EAF0D5;
  z-index: 100;
  max-width: fit-content;
  vertical-align: middle;
  p {
    text-align: center;
  }
  &.height-default {
    max-height: 620px;
    width: 100%;
    overflow-y: auto;
  }
  @media screen and (max-width: 1024px) and (max-height: 500px) {
    &.height-default {
      max-height: 350px;
      width: 100%;
      overflow-y: auto;
    }
  }
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 6px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  &::-webkit-scrollbar-button {
    background-color: transparent;
  }
  &.w-large {
    max-width: 800px;
    width: 800px;
  }
`;

export const ModalTitle = styled.p`
  color: #1d1f21;
  font-size: 20px;
  position: relative;
  margin-bottom: 15px;
`;

export const ModalContent = styled.div`
  color: #8d8d8d;
  font-size: 16px;
  /* margin-bottom: 22px; */
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #08ba98;
  line-height: 1.69;
  flex: 1;
  &.center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const ModalButton = styled.div`
  display: flex;
  justify-content: center;
  button {
    font-size: 14px;
    padding: 15px 0;
    border-radius: 5px;
    text-align: center;
  }
`;

export const ModalCancel = styled.button`
  border: solid 2px #1d1f21;
  color: #1d1f21;
  width: 136px;
  margin-right: 10px;
  background-color: white;
`;

export const ModalConfirm = styled.button`
  background-color: #1d1f21;
  color: white;
  border: none;
  width: 140px;
`;

export const ButtonStyled = styled.button`
  color: #fff;
  background: linear-gradient(113.96deg, #00ffed 0%, #00b8ba 100%);
  text-align: center;
  outline: none;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  padding: 7px 25px;
  border-radius: 6px;
  min-width: 80px;
  border: none;

  &.not-allowed {
    cursor: not-allowed;
  }

  @media screen and (max-width: 768px) {
    width: auto;
  }
`;

export const ButtonCancel = styled.button`
  text-align: center;
  color: white;
  outline: none;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  padding: 7px 20px;
  background-color: transparent;
  border-radius: 6px;
  border: 1px solid #00ffed;
  margin-right: 16px;
  min-width: 80px;
  &:hover {
    color: #00ffed;
  }
`;

export const FooterModal = styled.div`
  display: flex;
  justify-content: center;
  button {
    margin-bottom: 0;
  }
`;
